var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup49(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5925 14.6667H2.74066C1.96337 14.6667 1.33325 15.2339 1.33325 15.9334V16.0667C1.33325 16.7663 1.96337 17.3334 2.74066 17.3334H26.5925C27.3698 17.3334 27.9999 16.7663 27.9999 16.0667V15.9334C27.9999 15.2339 27.3698 14.6667 26.5925 14.6667Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8742 21.3333H7.79267C7.17084 21.3333 6.66675 21.9004 6.66675 22.5999V22.7333C6.66675 23.4328 7.17084 23.9999 7.79267 23.9999H26.8742C27.496 23.9999 28.0001 23.4328 28.0001 22.7333V22.5999C28.0001 21.9004 27.496 21.3333 26.8742 21.3333Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8742 8H7.79267C7.17084 8 6.66675 8.56711 6.66675 9.26667V9.4C6.66675 10.0996 7.17084 10.6667 7.79267 10.6667H26.8742C27.496 10.6667 28.0001 10.0996 28.0001 9.4V9.26667C28.0001 8.56711 27.496 8 26.8742 8Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup49);
export default __webpack_public_path__ + "static/media/Group 49.d198d5399d6c70bc9cf8db80378b8905.svg";
export { ForwardRef as ReactComponent };